// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-order-edit-payment-creditcard-maintenance[data-v-e5fb152a]{font-weight:700}", ""]);
// Exports
module.exports = exports;
